export default __webpack_public_path__ + "static/negative-former-eksempel4-07b2786033ee8e9960732040baf00582.png";